import "./style.scss";

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { IconButton } from "@mui/material";
import React from "react";

type OwnProps = {
    pageId: string
}

/**
 * @typedef OwnProps
 * @prop {string} pageId
 */

/**
 * Component for fullscreen element by element ID
 * @component
 * @param {OwnProps} props
 * @return {React.ReactElement} 
 */
export default function FullScreenPage(props: OwnProps) {
    const toggleFullScreen = React.useCallback((): void => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            document.querySelector(`#${props.pageId}`)?.requestFullscreen();
        }
    }, []);

    return (
        <div className="toggle-fullscreen">
            <IconButton onClick={toggleFullScreen} aria-label="delete" classes={{root: 'fullscreen-button'}}>
                <FullscreenIcon />
            </IconButton>
        </div>
    )
}